import React from 'react'
import { Icon } from 'semantic-ui-react'

export interface IBooleanCellProps {
  content: boolean
}

export const BooleanCell: React.FC<IBooleanCellProps> = props => {
  return props.content ? <Icon name='check' size='large' data-testid='boolean-cell-type' /> : null
}

export default React.memo(BooleanCell)
